import { useEffect, useRef } from "react";
import L, { Map } from "leaflet";
import { Position } from "@turf/turf";
import Coordinate from "@/components/coordinate/coordinate";
import { PointMap } from "@/features/map/utils/pointmap";
import { locateMe } from "@/features/map/utils/geolocator";
import { MapType } from "@/features/map/utils/agromap.type";
import { Farm } from "@/features/farm/domain/farm.interface";
// @ts-ignore
import Location from "@assets/icons/location.png";

interface AgroMapPointProps {
  type: MapType;
  mapId: string;
  toolbarOptions: L.PM.ToolbarOptions;
  markerIcon: L.Icon<L.IconOptions> | L.DivIcon;
  farmerFarms?: Farm[];
  currentPoint?: Position;
  samplingStationPoints?: { latitude: number; longitude: number }[];
  mapForWhatReport?: "EXPERIMENT" | "VISIT";
  onConfirm?: (point: Position) => void;
  onCancel?: () => void;
}

const AgroMapPoint = ({
  type,
  mapId,
  toolbarOptions,
  markerIcon,
  farmerFarms,
  currentPoint,
  samplingStationPoints,
  mapForWhatReport,
  onConfirm,
}: AgroMapPointProps) => {
  const popupRef = useRef<HTMLDivElement>(null);

  const pointMap = new PointMap(
    popupRef,
    toolbarOptions,
    markerIcon,
    type,
    farmerFarms,
    currentPoint,
    onConfirm
  );

  const coordinateRef = useRef<(e: any) => Map | undefined>();

  useEffect(() => {
    if (document.getElementById(`map${mapId}`)) {
      pointMap.init(mapId);

      currentPoint && pointMap.pinMarker(currentPoint);

      samplingStationPoints &&
        mapForWhatReport &&
        samplingStationPoints?.length > 0 &&
        pointMap.pinCircleBadge(samplingStationPoints, mapForWhatReport!);
      pointMap.initEditListeners();

      farmerFarms?.forEach((farm) => {
        pointMap.mapPolygon(farm.polygon, false, true, -1);
      });

      coordinateRef.current = (e: any) => pointMap.map?.flyTo(e);
    }
  }, [currentPoint]);

  return (
    <div className="relative h-full w-full rounded-lg font-body">
      {/* map */}
      <div id={`map${mapId}`} className="h-full w-full rounded-lg" />

      {/* searchBox */}
      <div
        id="searchAndHelp"
        className="flex max-lg:flex-col absolute gap-4 max-lg:gap-1 left-1/2 transform -translate-x-1/2 top-4 z-[999]"
      >
        {type !== "onlyShow" && (
          <Coordinate
            cityId={null}
            findCity={(e: any) => coordinateRef.current!(e)}
          />
        )}
      </div>

      {/* popUp area */}
      <div
        ref={popupRef}
        id="popup"
        className="absolute hidden h-8 w-64 max-lg:w-fit max-lg:bottom-4 gap-4 left-5 bottom-3 z-[999] bg-[#E9F0F7] rounded-full justify-start items-center max-lg:pl-8 px-4"
      >
        <p></p>
      </div>
      {/* locator button */}
      {type !== "onlyShow" && (
        <div
          id="locator"
          className="circle-neo absolute flex justify-center items-center p-2 left-2 bottom-2.5 max-lg:bottom-3 max-lg:left-2 h-10 w-10 rounded-full z-[999] cursor-pointer"
          onClick={() => locateMe(pointMap.map!)}
        >
          <img src={Location} alt="" />
        </div>
      )}
      {/* tour guide */}
      {/* <Tour
        type="primary"
        className="!bg-green-500"
        open={openTour}
        steps={tourSteps(
          findFarmTourRef.current,
          drawPolygonTourRef.current,
          editPolygonTourRef.current,
          deletePolygonTourRef.current
        )}
        onClose={() => {
          setOpenTour(false);
        }}
      /> */}
    </div>
  );
};

export default AgroMapPoint;
